import gql from 'graphql-tag'

export default gql`query user($user_id: Int!) {
  user(user_id: $user_id) {
    user_id
    dashboard_widgets {
      id
      name
      description
      settings
    }
  } 
}
`